export default function ProductEcosystem() {
  const appStoreUrl = 'https://apps.apple.com/us/app/i-say-i-am/id6762150286';

  const handleExternalLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleSpotifyLink = () => {
    // Replace with actual Spotify podcast link
    window.open('https://open.spotify.com', '_blank');
  };

  return (
    <section id="products" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-4">
            Choose Your Path
          </h2>
          <p className="text-lg text-[#4A4A4A] max-w-2xl mx-auto">
            Digital tools and physical journals. Pick what works best for your lifestyle and practice.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Mobile App */}
          <div 
            onClick={() => handleExternalLink(appStoreUrl)}
            className="group bg-gradient-to-br from-[#FFF5F0] to-[#FFFBF0] rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-[#E5E5E5] cursor-pointer"
          >
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <i className="ri-smartphone-line text-3xl text-[#2C2C2C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">Mobile App</h3>
            <p className="text-[#4A4A4A] mb-6 leading-relaxed">
              Daily affirmations, guided reflections, and progress tracking in your pocket. Available on iOS and Android.
            </p>
            <div className="flex items-center text-[#2C2C2C] font-semibold group-hover:gap-3 gap-2 transition-all">
              <span>Download</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </div>

          {/* I say I am podcast */}
          <div 
            onClick={handleSpotifyLink}
            className="group bg-gradient-to-br from-[#FFE8DC] to-[#FFF2E9] rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-[#E5E5E5] cursor-pointer"
          >
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <i className="ri-headphone-line text-3xl text-[#2C2C2C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">I say I am podcast</h3>
            <p className="text-[#4A4A4A] mb-6 leading-relaxed">
              Guided meditation and affirmation audio tracks. Perfect for morning routines or evening wind-down.
            </p>
            <div className="flex items-center text-[#2C2C2C] font-semibold group-hover:gap-3 gap-2 transition-all">
              <span>Listen on Spotify</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </div>

          {/* Daily Affirmations Book */}
          <div 
            onClick={() => handleExternalLink('https://www.amazon.com/dp/B0G6TM6JW3')}
            className="group bg-gradient-to-br from-[#F0FFF4] to-[#F5FFF8] rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-[#E5E5E5] cursor-pointer"
          >
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <i className="ri-heart-3-line text-3xl text-[#2C2C2C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">Daily Affirmations Book</h3>
            <p className="text-[#4A4A4A] mb-6 leading-relaxed">
              Dedicated space for daily affirmations, intention-setting, and positive self-talk. Beautifully designed for daily use. Available on Amazon.
            </p>
            <div className="flex items-center text-[#2C2C2C] font-semibold group-hover:gap-3 gap-2 transition-all">
              <span>Shop on Amazon</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </div>

          {/* Gratitude Journal Book */}
          <div 
            onClick={() => handleExternalLink('https://www.amazon.com/dp/B0G6V4QDR1')}
            className="group bg-gradient-to-br from-[#F5F0FF] to-[#FAF5FF] rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-[#E5E5E5] cursor-pointer"
          >
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <i className="ri-book-open-line text-3xl text-[#2C2C2C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">Gratitude Journal Book</h3>
            <p className="text-[#4A4A4A] mb-6 leading-relaxed">
              Beautiful physical journal for daily gratitude practice. Premium paper quality, thoughtful prompts. Available on Amazon.
            </p>
            <div className="flex items-center text-[#2C2C2C] font-semibold group-hover:gap-3 gap-2 transition-all">
              <span>Shop on Amazon</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </div>

          {/* Reflections Journal Book */}
          <div 
            onClick={() => handleExternalLink('https://www.amazon.com/dp/B0H1WLGSY6')}
            className="group bg-gradient-to-br from-[#FFF0F5] to-[#FFF5F8] rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-[#E5E5E5] cursor-pointer"
          >
            <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <i className="ri-quill-pen-line text-3xl text-[#2C2C2C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">Reflections Journal Book</h3>
            <p className="text-[#4A4A4A] mb-6 leading-relaxed">
              Guided reflection journal with prompts for self-discovery and personal growth. Perfect for evening practice. Available on Amazon.
            </p>
            <div className="flex items-center text-[#2C2C2C] font-semibold group-hover:gap-3 gap-2 transition-all">
              <span>Shop on Amazon</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
